import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Building2, MessagesSquare, FileText, Clock } from 'lucide-react';

const copy = {
  en: {
    title: 'Early Clinical Traction',
    items: [
      { value: '3', label: 'clinic environments engaged since 2022', Icon: Building2 },
      { value: '1,029+', label: 'consultations processed', Icon: MessagesSquare },
      { value: '807+', label: 'structured medical records generated', Icon: FileText },
      { value: '77+', label: 'clinician hours saved on documentation', Icon: Clock },
    ],
  },
  uk: {
    title: 'Перші клінічні результати',
    items: [
      { value: '3', label: 'клінічних середовища задіяно з 2022 року', Icon: Building2 },
      { value: '1 029+', label: 'оброблених консультацій', Icon: MessagesSquare },
      { value: '807+', label: 'згенерованих структурованих медичних записів', Icon: FileText },
      { value: '77+', label: 'годин лікарів зекономлено на документації', Icon: Clock },
    ],
  },
  ja: {
    title: '初期の臨床実績',
    items: [
      { value: '3', label: '2022年以降に参画した臨床現場', Icon: Building2 },
      { value: '1,029+', label: '処理された診療件数', Icon: MessagesSquare },
      { value: '807+', label: '生成された構造化診療記録', Icon: FileText },
      { value: '77+', label: '文書作成で節約された臨床時間', Icon: Clock },
    ],
  },
};

export default function EarlyTractionSection() {
  const { lang } = useLanguage();
  const c = copy[lang];

  return (
    <section className="section-padding">
      <div className="container-max max-w-6xl">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-bold text-foreground text-center mb-10"
        >
          {c.title}
        </motion.h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {c.items.map((item, i) => {
            const Icon = item.Icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="card-elevated p-6 text-center"
              >
                <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-4">
                  <Icon size={20} className="text-primary" />
                </div>
                <div className="stat-number">{item.value}</div>
                <p className="text-sm text-muted-foreground leading-relaxed mt-2">{item.label}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
